module.exports = __webpack_public_path__ + "static/media/006-tanzania.d05c7767.svg";